import strings from 'utils/strings';

export function getPronoun(gender) {
	if (gender === 'm') {
		return strings.pronouns.pronounHan;
	} else if (gender === 'f') {
		return strings.pronouns.pronounHon;
	}
	return strings.pronouns.pronounHen;
}
